import { useQuery } from '@tanstack/react-query';
import { dashboardServices } from '../services/dashboard.service';

export const useTopSellersByBookings = (params) => {

  return useQuery({

    queryKey: ['top-sellers-by-bookings', params],

    queryFn: () =>
      dashboardServices.getTopSellersByBookings(params),

    staleTime: 5 * 60 * 1000,
  });
};